import "./_style.less";
import { VuiStep, VuiSteps, VuiTitle } from "../../@vendor/components";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import {
  BillIcon,
  CartDoneStep,
  CartPaymentStep,
  TickIcon,
} from "../../components";
import { CreateBookingResponse } from "../../models/Booking";
import { useCheckoutBookingCounseling } from "../booking-counseling/providers/checkout-booking-counseling.provider";
import { useBookingCounseling } from "../booking-counseling/providers/booking-counseling.provider";

export interface OrderSummary {
  subTotal: number;
  total: number;
}

type StepType = "payment" | "done";

const StepsCurrent = {
  payment: 0,
  done: 1,
};

const GuestCheckoutBookingCounselingModule = () => {
  const { t } = useTranslation();
  const { resetForm, resetStep } = useBookingCounseling();
  const { bookingData, onChangeBookingData } = useCheckoutBookingCounseling();
  const [orderSummary, setOrderSummary] = useState<OrderSummary>({
    subTotal: 0,
    total: 0,
  });
  const [currentStep, setCurrentStep] = useState<StepType>("payment");
  const [bookingResponse, setBookingResponse] =
    useState<CreateBookingResponse | null>(null);

  useEffect(() => {
    if (bookingData) {
      setOrderSummary({
        subTotal: bookingData?.subtotal ?? 0,
        total: bookingData?.total ?? 0,
      });
    }
  }, [bookingData]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCheckoutPayment = useCallback(
    (data: CreateBookingResponse) => {
      setBookingResponse(data);
      setCurrentStep("done");
      scrollToTop();
      onChangeBookingData(null);
      resetForm();
      resetStep();
    },
    [resetStep, resetForm, onChangeBookingData]
  );

  return (
    <div className="container">
      <VuiTitle text={t("common.text.checkout")} />

      <div className="cart-steps-wrapper">
        <VuiSteps current={StepsCurrent[currentStep]} labelPlacement="vertical">
          <VuiStep icon={<BillIcon />} title={t("common.text.payment")} />
          <VuiStep icon={<TickIcon />} title={t("common.text.done")} />
        </VuiSteps>
      </div>

      <div className="cart-content-wrapper">
        <div className="cart-content">
          {currentStep === "payment" && (
            <CartPaymentStep
              orderSummary={orderSummary}
              checkedCart={[]}
              onCheckout={handleCheckoutPayment}
              isGuestMode={true}
              guestCounselingBookingData={bookingData}
            />
          )}

          {currentStep === "done" && (
            <CartDoneStep isGuestMode={true} data={bookingResponse} />
          )}
        </div>
      </div>
    </div>
  );
};

export default GuestCheckoutBookingCounselingModule;
